


const addThreeHoursToISO = (dateString) => {
    // Verilen tarih stringini parçalayıp Date objesi oluştur
    let date = new Date(dateString);

    // 3 saat ekle
    date.setHours(date.getHours() + 3);

    // Orijinal stringin küçük saniyeler kısmını koruyalım
    const fractionalSeconds = dateString.split('.')[1];

    // Tarihi ISO stringine çevir
    let isoString = date.toISOString();

    // Küçük saniyeler kısmını ekleyerek stringi yeniden oluştur
    return isoString.split('.')[0] + '.' + fractionalSeconds;
}

export default addThreeHoursToISO